import { Details } from './gb-details';
riot.tag2('gb-details', '<div class="gb-details"> <yield></yield> </div>', '', '', function(opts) {
    this._mixin(Details);
});



/** WEBPACK FOOTER **
 ** ./src/tags/details/gb-details.tag.html
 **/